import type { ReactNode } from "react";
import { cx } from "./primitives";

/**
 * A labelled figure on the panel ground — the profile's stat tiles, and (2026-09-13)
 * the card each Feed leaderboard sits on. `value` alone is the profile's shape; pass
 * `children` for a card that carries rows under its label.
 */
export function Tile({
  label,
  value,
  accent,
  children,
  className,
}: {
  label: string;
  value?: string;
  accent?: boolean;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx("rounded-xl border border-[var(--color-edge)] bg-[var(--color-panel)] p-4", className)}>
      <div className="text-[11px] uppercase tracking-wide text-zinc-500">{label}</div>
      {value !== undefined ? (
        <div
          className={cx("mt-1 truncate text-xl font-semibold", accent ? "text-[var(--color-accent-soft)]" : "text-zinc-100")}
          title={value}
        >
          {value}
        </div>
      ) : null}
      {children}
    </div>
  );
}
